import React, { useEffect, useState } from 'react'
import SelectFacet from '../../SearchFacets/SelectFacet'
import ResultPreview from './Results/ResultPreview/ResultPreview'
import SideNavGroups from './SideNavigation/SideNavGroups/SideNavGroups'
import { findingsQuery } from '../../../queries'
import SideNavContentTypes from './SideNavigation/SideNavContentTypes/SideNavContentTypes'
import './Findings.scss'
import { ContentSearchBar } from './ContentSearchBar/ContentSearchBar'
import { KeyboardBackspace } from '@material-ui/icons'
import { Typography } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { constants } from '../../../lib/constants'
import ResultModal from './Results/ResultModal/ResultModal'

export const Findings = () => {
  const auditID = 1
  const QIID = 1
  const CAPAID = 1
  const [filter, setFilter] = useState({
    group: constants.filter.all,
    text: ''
  })
  const history = useHistory()
  const [dataToDisplay, setDataToDisplay] = useState()
  const [allData, setAllData] = useState()
  const [shouldShowModal, setShouldShowModal] = useState(false)
  const [selectedItem, setSelectedItem] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [hasLoadingError, setHasLoadingError] = useState(false)

  useEffect(() => {
    fetch(`${process.env.REACT_APP_TARGET_URL}/graphql`, {
      method: 'POST',
      mode: 'cors',
      credentials: 'include',
      body: JSON.stringify({ query: findingsQuery() })
    })
      .then(response => response.json())
      .then(response => {
        setAllData(response?.data?.nodeQuery?.entities)
        setDataToDisplay(response?.data?.nodeQuery?.entities)
      })
      .catch(() => setHasLoadingError(true))
      .finally(() => setIsLoading(false))
    // Filter for groups.
    switch (filter.group) {
      case constants.filter.all:
        setDataToDisplay(allData)
        break
      case constants.filter.none:
        setDataToDisplay(allData.filter(item => !item.group))
        break
      default:
        setDataToDisplay(allData.filter(item => item.group === filter.group))
        break
    }
    // Filter for text.
    if (filter.text.length > 0) {
      setDataToDisplay(data =>
        (data.filter(item =>
          JSON.stringify(item).toLowerCase().indexOf(filter.text.toLowerCase()) > -1)))
    }
  }, [allData, filter])

  const filterType1 = [
    constants.filter.all,
    constants.filter.none,
    ...(new Set(allData?.reduce((acc, entity) => {
      if (entity.group) {
        acc.push(entity.group)
      }
      return acc
    }, [])))
  ]

  const filterData = category => value => {
    setFilter(data => ({
      ...data,
      [category]: value
    }))
  }

  const createPages = (item) => {
    const pages = [
      {
        topic: 'Base Information',
        fields: [
          `Audit ID: ${item.findingAuditID?.entity.title}`,
          `Classification: ${item.findingClassification?.entity.title}`,
          `Clinical E2E Core Category: ${item.findingClinE2ECat?.entity.title}`,
          `Compliance Topic: ${item.findingComplianceTopic?.entity.title} - ${item.findingComplianceSubTopic?.entity.title} `,
          `Department: ${item.findingDepartment?.entity.title} - ${item.findingSubdepartment?.entity.title} `,
          `Quality Process: ${item.findingQualityProcess?.entity.title}`,
          `Quality Process Group: ${item.findingQualityProcessGroup?.entity.title}`,
          'Group: ',
          `Source System: ${item.findingSourceSystem?.entity.title}`,
          `Type: ${item?.findingTitle}`
        ]
      },
      {
        topic: 'Detailed Information',
        fields: [
          `Description: ${item.findingDescription?.value}`,
          `Details: ${item.findingDetails?.value}`
        ]
      }
    ]
    return pages
  }

  const createPreviews = (data) => {
    return data && data.map((item, i) =>
      <ResultPreview
        key={i}
        title={item.title}
        nid={item.nid}
        naturalKey={item.naturalKey}
        openModalCallback={() => {
          setSelectedItem(item)
          setShouldShowModal(true)
        }}
      />)
  }

  if (hasLoadingError) {
    return (
      <div className='quality-investigations-wrapper'>
        <div className='header-wrapper'>
          <div className='back-button__clickable' onClick={() => { history.goBack() }}>
            <KeyboardBackspace /> <Typography>Back</Typography>
          </div>
        </div>
        No data was found for this Findings.
      </div>
    )
  }

  return !isLoading && allData && (
    <div className='content-findings-wrapper'>
      <div className='header-wrapper'>
        <div className='back-button__clickable' onClick={() => { history.goBack() }}>
          <KeyboardBackspace /> <Typography>Back</Typography>
        </div>
        <div className='content-title'>
          <Typography variant='h3'>
            Findings
          </Typography>
        </div>
      </div>
      <div className='search-bar-wrapper'>
        <ContentSearchBar
          setFilter={value => setFilter(data => ({
            ...data,
            text: value
          }))}
        />
      </div>
      <div className='result-wrapper'>
        <div className='filter-wrapper--left-column'>
          <SelectFacet
            onChange={(value) => {
              filterData('group')(value)
            }}
            selectOptions={filterType1}
            title='Group'
          />
        </div>
        <div className='table-wrapper'>
          {createPreviews(dataToDisplay)}
        </div>
        <div className='sidebar-wrapper--right-column'>
          <SideNavContentTypes
            contentType='Audit'
            number={1}
            link={`/content/audits/${auditID}`}
          />
          <SideNavContentTypes
            contentType='Quality Investigations'
            number={5}
            link={`/content/qis/${QIID}`}
          />
          <SideNavContentTypes
            contentType='CAPAs'
            number={5}
            link={`/content/capas/${CAPAID}`}
          />
          <SideNavGroups />
        </div>
      </div>
      {Object.keys(selectedItem).length > 0 &&
        <ResultModal
          isOpen={shouldShowModal}
          onClose={() => setShouldShowModal(false)}
          nid={selectedItem.nid}
          naturalKey={selectedItem.naturalKey}
          title={selectedItem.title}
          pages={createPages(selectedItem)}
        />}
    </div>
  )
}
